import 'babel-polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import { Container } from '@cerebral/react';
import { ThemeProvider } from 'react-css-themr';
import { Helmet } from 'react-helmet';

import App from './App';
// import registerServiceWorker from './registerServiceWorker';
import controller from './store/controller';
import './styles/main.scss';
import { CdnContext } from './context';

const contextTheme = {};
const branch = process.env.CIRCLE_BRANCH;
const cdn = {
    master: '//d2ee3vjd9zwq54.cloudfront.net/',
    staging: '//039005-5f03-03a3-0001.staging.s.bitsof.love/', // '//s3.eu-central-1.amazonaws.com/bitsoflove-staging/039005-5f03-03a3-0001/',
    develop: '//039005-5f03-03a3-0001.develop.s.bitsof.love/', // '//s3.eu-central-1.amazonaws.com/bitsoflove-develop/039005-5f03-03a3-0001/',
};

ReactDOM.render(
    <ThemeProvider theme={contextTheme}>
        <Container controller={controller}>
            <Helmet>
                {branch !== 'develop' && (
                    <link rel="stylesheet" href={`${cdn[branch]}styles.css`} />
                )}
                <script>
                    {`
                    var _paq = window._paq = window._paq || [];
                    _paq.push(['trackPageView']);
                    (function() {
                        var u="https://vad.matomo.cloud/";
                        _paq.push(['setTrackerUrl', u+'matomo.php']);
                        _paq.push(['setSiteId', '3']);
                        var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
                        g.async=true; g.src='//cdn.matomo.cloud/vad.matomo.cloud/matomo.js'; s.parentNode.insertBefore(g,s);
                    })();`}
                </script>
            </Helmet>
            <CdnContext.Provider value={cdn[branch] || ''}>
                <App cdn={cdn[branch] || ''} />
            </CdnContext.Provider>
        </Container>
    </ThemeProvider>,
    document.getElementById('bol-zelfhulptool')
);



// WEBPACK FOOTER //
// ./src/index.js